import { ASSETS_URL, ReviewProduct, ReviewType, VideoReview } from '../../types';
import poster from '@/static/assets/reviews/ChanelAllen/video.jpg';
import subs from '@/static/assets/reviews/ChanelAllen/subs.vtt';

export const ChanelAllen: VideoReview = {
  type: ReviewType.Video,
  product: [ReviewProduct.Renters],
  reviewerName: 'Chanel',
  videoUrl: `${ASSETS_URL}/renters/ChanelAllen_Renters.webm`,
  posterUrl: poster,
  captionsUrl: subs,
};
